import { MTCountryOption } from '@/multi-territory/mt-types/mt-admin'

export const COUNTRY_OPTIONS: MTCountryOption[] = [
  {
    uuid: 'f18c8ec0-76bc-4f90-833b-1ad9f45b0a33',
    country_code: 'IND',
    country_name: 'India',
    tax_registration_required: true,
    uin_regex: '[A-Z]{5}[0-9]{4}[A-Z]',
    identifier_name: 'PAN',
  },
  {
    uuid: '63600b8e-024b-442d-88f6-8819ca270bd5',
    country_code: 'SG',
    country_name: 'Singapore',
    tax_registration_required: true,
    uin_regex: '[0-9]{9}[A-Z]',
    identifier_name: 'TIN',
  },
  {
    uuid: '705153df-d00b-41bd-a744-94c7e368483b',
    country_code: 'GB',
    country_name: 'United Kingdom',
    tax_registration_required: false,
    uin_regex: '[0-9]{10}',
    identifier_name: '',
  },
]
